import { forwardRef } from 'react'
import { useInputTextContext } from '../../input-text'
import type {
  InputTextFieldProps,
  InputTextScopedProps,
} from '../../input-text.types'
import { inputTextFieldVariants } from './index.styles'

export const InputTextField = forwardRef<HTMLInputElement, InputTextFieldProps>(
  (
    {
      __scopeInputText,
      onFocus,
      onBlur,
      ...props
    }: InputTextScopedProps<InputTextFieldProps>,
    ref
  ) => {
    const { disabled, readOnly, size, isActive, setActive } =
      useInputTextContext('InputTextField', __scopeInputText)

    const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
      setActive(true)
      onFocus?.(event)
    }
    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
      setActive(false)
      onBlur?.(event)
    }
    return (
      <input
        {...props}
        ref={ref}
        disabled={disabled}
        readOnly={readOnly}
        placeholder="Placeholder is hidden"
        className={inputTextFieldVariants({
          disabled,
          readOnly,
          isActive,
          size,
        })}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    )
  }
)

InputTextField.displayName = 'InputTextField'
